<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container v-if="isLoading" fluid class="justify-center fill-height">
        <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
    </v-container>
    <div v-else>
        <v-toolbar class="elevation-1">
            <v-toolbar-title>{{ title }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <template>
                <v-btn
                        color="primary"
                        class="ma-0"
                        min-width="0"
                        @click="submitWorkHours"
                >
                    <v-icon>done</v-icon>
                </v-btn>
            </template>
        </v-toolbar>

        <v-form autocomplete="off"
                ref="form"
                v-model="valid"
        >
            <!-- Developer and date form -->
            <FormCard>
                <template v-slot:form>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                            <!-- Developer select -->
                            <v-select class="custom_textfield"
                                      :items="select_field_developers"
                                      v-model="developer_id"
                                      :label="$t('general.developer')"
                                      type="select"
                                      item-text="name"
                                      item-value="id"
                                      outlined
                                      :rules="field_required_rule"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                            <!-- Date input -->
                            <v-menu v-model="date_picker"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field class="custom_textfield"
                                                  v-model="computedDateFormatted"
                                                  :label="$t('general.date')"
                                                  append-icon="event"
                                                  readonly
                                                  v-on="on"
                                                  outlined
                                                  :rules="field_required_rule"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="date"
                                               @input="date_picker = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col v-if="!work_hour_id" cols="12" sm="6" md="6" lg="6" xl="6"
                               class="d-flex justify-end justify-sm-start justify-md-end">
                            <!-- "Add work hour" button -->
                            <v-btn color="primary"
                                   @click="createWorkHour"
                                   v-html="$t('workHours.add_work_hours')"
                            ></v-btn>
                        </v-col>
                    </v-row>
                </template>
            </FormCard>

            <!-- Work hour form -->
            <FormCard v-for="(value, index) in work_hours" :key="index">
                <template v-slot:form>
                    <!-- Close button -->
                    <v-row dense
                           v-if="index !== work_hours.length - 1"
                    >
                        <v-spacer></v-spacer>
                        <v-btn icon
                               class="top_close_btn"
                               @click="deleteWorkHourForm(index, $event)"
                        >
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-row>
                    <!-- Form fields -->
                    <v-row dense class="work_hour_row">
                        <!-- First 4 fields -->
                        <v-col cols="12" sm="12" md="6" lg="6">
                            <v-row dense>
                                <!-- Client -->
                                <v-col cols="12" sm="6" md="6" lg="6">
                                    <v-select class="custom_textfield"
                                              :label="$t('general.client')"
                                              type="select"
                                              :items="select_field_clients"
                                              v-model="value.client_id"
                                              item-text="name"
                                              item-value="id"
                                              outlined
                                              @change="getSelectFieldProjects(index, $event)"
                                              :rules="field_required_rule"
                                    ></v-select>
                                </v-col>
                                <!-- Project -->
                                <v-col cols="12" sm="6" md="6" lg="6">
                                    <v-select
                                            class="custom_textfield"
                                            :label="$t('general.project')"
                                            type="select"
                                            :items="work_hours[index].select_field_projects"
                                            v-model="value.project_id"
                                            item-text="name"
                                            item-value="id"
                                            outlined
                                            :rules="field_required_rule"
                                    ></v-select>
                                </v-col>
                                <!-- Start time -->
                                <v-col cols="12" sm="6" md="6" lg="6">

                                    <!--<v-text-field-->
                                            <!--:id="`custom_start_time_${index}`"-->
                                            <!--class="custom_textfield"-->
                                            <!--v-model="value.start_time"-->
                                            <!--:label="$t('workHours.start_time')"-->
                                            <!--append-icon="access_time"-->
                                            <!--readonly-->
                                            <!--outlined-->
                                            <!--:rules="field_required_rule"-->
                                    <!--&gt;</v-text-field>-->

                                    <vue-timepicker class="work_hour_time_picker"
                                                    v-model="value.start_time"
                                                    format="HH:mm"
                                                    minute-interval="15"
                                    ></vue-timepicker>

                                </v-col>
                                <!-- End time -->
                                <v-col cols="12" sm="6" md="6" lg="6">

                                    <!--<v-text-field-->
                                            <!--:id="`custom_end_time_${index}`"-->
                                            <!--class="custom_textfield"-->
                                            <!--v-model="value.end_time"-->
                                            <!--:label="$t('workHours.end_time')"-->
                                            <!--append-icon="access_time"-->
                                            <!--readonly-->
                                            <!--outlined-->
                                            <!--:rules="field_required_rule"-->
                                    <!--&gt;</v-text-field>-->

                                    <vue-timepicker class="work_hour_time_picker"
                                                    v-model="value.end_time"
                                                    format="HH:mm"
                                                    minute-interval="15"
                                    ></vue-timepicker>

                                </v-col>
                            </v-row>
                        </v-col>
                        <!-- Text area -->
                        <v-col cols="12" sm="6" md="3" lg="3">
                            <v-row dense>
                                <v-col>
                                    <v-textarea auto-grow
                                                :label="$t('workHours.description')"
                                                v-model="value.description"
                                                rows="3"
                                                row-height="28"
                                                outlined
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                        </v-col>
                        <!-- Checkboxes -->
                        <v-col cols="12" sm="6" md="3" lg="3">
                            <v-row dense>
                                <v-col>
                                    <v-checkbox class="custom_checkbox"
                                                v-model="value.billable"
                                                :label="`${$t('workHours.billable_hours')}`"></v-checkbox>
                                    <v-checkbox class="custom_checkbox"
                                                v-model="value.invoiced"
                                                :label="`${$t('workHours.invoiced_hours')}`"></v-checkbox>
                                    <v-checkbox class="custom_checkbox"
                                                v-model="value.paid"
                                                :label="`${$t('workHours.paid_hours')}`"></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </template>
            </FormCard>
        </v-form>
    </div>
</template>

<script>
    import FormCard from '../components/FormCard.vue'
    import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

    // Main JS (in UMD format)
    import VueTimepicker from 'vue2-timepicker'

    // CSS
    import 'vue2-timepicker/dist/VueTimepicker.css'

    export default {
        components: {
            FormCard, datePicker: VuePersianDatetimePicker, VueTimepicker
        },
        props: {
            title: {
                type: String
            },
            work_hour_id: {
                default: null
            }
        },
        data() {
            return {
                isLoading: false,
                developer_id: null,
                date: new Date().toISOString().substr(0, 10),
                date_picker: false,
                initial_form: {
                    client_id: null,
                    project_id: null,
                    start_time: '09:00',
                    start_time_picker: null,
                    end_time: '17:00',
                    end_time_picker: false,
                    description: '',
                    billable: true,
                    invoiced: false,
                    paid: false,
                    select_field_projects: []
                },
                work_hours: [
                    {
                        client_id: null,
                        project_id: null,
                        start_time: '09:00',
                        start_time_picker: null,
                        end_time: '17:00',
                        end_time_picker: false,
                        description: '',
                        billable: true,
                        invoiced: false,
                        paid: false,
                        select_field_projects: []
                    }
                ],

                // Validation
                valid: true,
                field_required_rule: [
                    v => !!v || `${this.$t('validation.required')}`
                ],
                time_validation_rules: [],

                select_field_developers: [],
                select_field_clients: [],
            }
        },
        computed: {
            computedDateFormatted() {
                return this.date ? this.moment(this.date).format('DD/MM/YYYY') : ''
            },
            computedRouteRepeat() {
                return this.$route.name === 'repeat_work_hours';
            },
        },
        async mounted() {
            this.isLoading = true;
            await this.getSelectFieldDevelopers();
            await this.getSelectFieldClients();

            // If work hour id is not null, edit work hour
            if (this.work_hour_id) {
                await this.fetchWorkHour();
            }

            this.isLoading = false;
        },
        methods: {
            // Saves time picker time on refs
            saveTime(ref, index, time) {
                this.$refs[ref][index].save(time);
            },
            // Add a new "create work hour" form
            createWorkHour() {
                this.work_hours.unshift(Object.assign({}, this.initial_form));
                this.work_hours[0].start_time = this.work_hours[1].end_time;
                this.resetValidation();
            },
            // Delete a work hour form
            deleteWorkHourForm(index, event) {
                this.work_hours.splice(index, 1);
            },

            // Get all developers for the select field
            async getSelectFieldDevelopers() {
                this.select_field_developers = (await this.$store.dispatch('fetchData', {
                    url: '/api/users/devs',
                    params: {conditions: {is_active: 1}}
                }))[0];

                // Select developer
                if (this.select_field_developers.length === 1) {
                    this.developer_id = this.select_field_developers[0].id;
                }
            },
            // Get all clients and their projects for the select fields options
            async getSelectFieldClients() {
                this.select_field_clients = (await this.$store.dispatch('fetchData', {
                    url: '/api/clients/all',
                    params: {projects_conditions: {is_active: 1}}
                }))[0];
            },
            // When a Client is selected find the projects associated with him to set in projects dropdown
            getSelectFieldProjects(index, client_id) {
                this.work_hours[index].project_id = null;
                this.work_hours[index].select_field_projects = [];

                // Find selected client object and get projects
                const selected_client = this.select_field_clients.find(element => element.id === client_id);

                if (selected_client.projects.length > 0) {
                    this.work_hours[index].select_field_projects = selected_client.projects;
                    // Set default selected project.
                    this.work_hours[index].project_id = selected_client.projects[0].id;
                }
            },

            // Validation
            validate() {
                return this.$refs.form.validate();
            },
            reset() {
                this.$refs.form.reset()
            },
            resetValidation() {
                this.$refs.form.resetValidation()
            },

            async submitWorkHours() {

                // Validate data
                if (this.validate()) {

                    let response = null;

                    // If work hour id is NN and current route is not repeat route, update
                    if (this.work_hour_id && !this.computedRouteRepeat) {

                        // Update data
                        response = await this.$store.dispatch('sendData', {
                            method: 'patch',
                            url: `/api/work-hours/${this.work_hour_id}`,
                            data: {data: this.filterData()}
                        });

                        // Else, create new entry
                    } else {

                        // Post data
                        response = await this.$store.dispatch('sendData', {
                            method: 'post',
                            url: `/api/work-hours`,
                            data: {data: this.filterData()}
                        });
                    }

                    // After successful action, redirect to view work hours
                    if (response && response.status === 200) {
                        this.$router.push('/work-hours/view')
                    }
                }
            },
            // Store data properly to save to db
            filterData() {
                let work_hours_formatted = [];
                this.work_hours.forEach((wh) => {
                    let form_object = {};
                    form_object.developer_id = this.developer_id;
                    form_object.client_id = wh.client_id;
                    form_object.project_id = wh.project_id;
                    form_object.start_time = `${this.date} ${wh.start_time}`;
                    form_object.end_time = `${this.date} ${wh.end_time}`;
                    form_object.description = wh.description;
                    form_object.billable = wh.billable;
                    form_object.invoiced = wh.invoiced;
                    form_object.paid = wh.paid;
                    form_object.duration = this.getTimeDuration(wh.start_time, wh.end_time);

                    work_hours_formatted.push(form_object);
                });

                return work_hours_formatted;
            },
            // Get work hours from API
            async fetchWorkHour() {
                let response = await this.$store.dispatch('fetchData', {
                    url: `/api/work-hours/${this.work_hour_id}`,
                });

                if (response.data) {
                    this.developer_id = response.data.developer_id;

                    for (let prop in this.work_hours[0]) {
                        (['start_time', 'end_time'].indexOf(prop) > -1) ? this.setDateTime(response.data[prop], prop)
                            : this.work_hours[0][prop] = response.data[prop];
                    }

                    // repeat
                    if (this.computedRouteRepeat) {
                        this.date = this.moment(response.data.start_time).add(1, 'days').format('YYYY-MM-DD');
                    }

                    this.getSelectFieldProjects(0, response.data.client_id);
                }
            },
            // Calculates time difference for two given times in string form.
            getTimeDuration(start_time, end_time) {
                let start = new Date();
                let end = new Date();

                start.setHours(start_time.substr(0, 2));
                start.setMinutes(start_time.substr(3, 3));
                start.setSeconds('00');
                end.setHours(end_time.substr(0, 2));
                end.setMinutes(end_time.substr(3, 3));
                end.setSeconds('00');

                return (Math.abs(start.getTime() - end.getTime()) / 36e5).toFixed(1);
            },
            // Properly formats and sets date and time fetched from database.
            setDateTime(date, time_field) {
                const datetime_parts = date.split(' ');
                this.date = datetime_parts[0];
                this.work_hours[0][time_field] = datetime_parts[1].substr(0, 5);
            }
        },

    }
</script>
